<div id="changelogWrapper">
  <!-- <img src="assets/images/stacks.png" [alt]="'Stacks' | translate"> -->
  <h1>{{ 'Changelog' | translate }}</h1>

  <mat-card>
    <mat-card-title>{{ 'Version 7.25' | translate }}</mat-card-title>
    <mat-card-subtitle>24-03-2026</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'New Features' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Bulk Category Assignment' | translate }}</strong> {{ '— assign multiple categories to products at once for faster catalog management.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Filter by Sub-Category' | translate }}</strong> {{ 'in the products list for more precise product browsing.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Introduced' | translate }} <strong>{{ 'Items per page' | translate }}</strong> {{ 'selector in custom pagination, giving users control over how many items are displayed per page.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Sender Email' | translate }}</strong> {{ 'configuration to commerce order email settings.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Introduced' | translate }} <strong>{{ 'Stock Manager' | translate }}</strong> {{ 'role with restricted access to relevant sections only.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          <span class="websitePadder">{{ 'Website' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Floating Social Buttons' | translate }}</strong> {{ '— display social media links as floating buttons in the app and website.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          <span class="websitePadder">{{ 'Website' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Custom Field' | translate }}</strong> {{ 'support in the website view for more flexible content configuration.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Floating Social Icons' | translate }}</strong> {{ 'in the app footer for quick access to social profiles.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Guest Checkout' | translate }}</strong> {{ 'toggle in social login configuration — allow customers to check out without creating an account.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'image file size validation' | translate }}</strong> {{ '— images are limited to 2MB and GIFs to 5MB, with clear hints shown in the UI.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Optional Sticky Header' | translate }}</strong> {{ '— the navbar sticky behavior can now be toggled on or off from the header settings.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          <span class="websitePadder">{{ 'Website' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'External Link' | translate }}</strong> {{ 'navigation option to website header and footer — link any header or footer item to an external URL.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Re-added' | translate }} <strong>{{ 'Android APK' | translate }}</strong> {{ 'download option directly from the builder.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Default Language' | translate }}</strong> {{ 'selection — set the default language for your app from the builder settings.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Introduced the' | translate }} <strong>{{ 'Checkout Builder' | translate }}</strong> {{ '— customize the checkout page layout and design.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="websitePadder">{{ 'Website' | translate }}</span>
          {{ 'Added support for' | translate }} <strong>{{ 'Product Variations' | translate }}</strong> {{ 'on the website, allowing customers to select options directly from the product page.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Coupon details' | translate }}</strong> {{ 'to the single order page — applied coupons are now visible within the order summary.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ '3-column and 4-column' | translate }}</strong> {{ 'layout options for sections.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'local image upload' | translate }}</strong> {{ 'for section backgrounds — pick an image directly from your device instead of using a URL.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Launched' | translate }} <strong>{{ 'FinCart integration' | translate }}</strong> {{ '— connect your store with FinCart for payment and financial management.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Import Products from URL' | translate }}</strong> {{ '— scrape and import product images and data directly from a URL using Apify.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Product Type and Variable Values' | translate }}</strong> {{ 'fields to the product editor.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Product cache is now' | translate }} <strong>{{ 'automatically updated' | translate }}</strong> {{ 'after a successful product save, ensuring the list always reflects the latest data without a manual refresh.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'sub-category saving' | translate }}</strong> {{ '— selecting a sub-category no longer overwrites existing category data.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Removed extra' | translate }} <strong>{{ '2-column and 3-column styles' | translate }}</strong> {{ 'from sections on mobile for a cleaner layout.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Improved' | translate }} <strong>{{ 'Orders' | translate }}</strong> {{ 'table layout for better readability and data presentation.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'product variation data' | translate }}</strong> {{ '— existing variation values are now preserved when regenerating variations instead of being overwritten.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'TikTok' | translate }}</strong> {{ 'icon styling and color in social settings.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'currency position' | translate }}</strong> {{ '— currency symbol now displays in the correct position relative to the price.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'product enable/disable toggle' | translate }}</strong> {{ '— toggling a product\'s status now updates correctly without needing a page refresh.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'custom domain' | translate }}</strong> {{ 'visibility — premium users now correctly see their custom domain in settings.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'product sorting' | translate }}</strong> {{ '— switching the filter between App and Website no longer requires re-selecting the sort option.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'smart order search index' | translate }}</strong> {{ '— automatically enabled for stores with more than 500 orders for faster order lookups.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'footer link alignment' | translate }}</strong> {{ 'in website style settings.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'product stock restoration' | translate }}</strong> {{ '— stock is automatically returned when an order is cancelled.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Updated' | translate }} <strong>{{ 'default shipping' | translate }}</strong> {{ 'configuration for a better out-of-the-box experience.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Pressing a' | translate }} <strong>{{ 'locked order' | translate }}</strong> {{ 'now shows an upgrade prompt instead of silently failing.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Removed the' | translate }} <strong>{{ 'Wishlist' | translate }}</strong> {{ 'feature to simplify the app experience.' | translate }}
        </li>
      </ul>

      <h2>{{ 'UX / UI Updates' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Redesigned the' | translate }} <strong>{{ 'Content Settings' | translate }}</strong> {{ 'page with improved layout and full WordPress compatibility.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Redesigned the' | translate }} <strong>{{ 'Users' | translate }}</strong> {{ 'management page for a cleaner and more intuitive experience.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Redesigned the' | translate }} <strong>{{ 'Apple Settings' | translate }}</strong> {{ 'page for a cleaner layout and easier configuration.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Updated the' | translate }} <strong>{{ 'Shipping' | translate }}</strong> {{ 'page with a new design for improved clarity.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Refined' | translate }} <strong>{{ 'Single Product' | translate }}</strong> {{ 'page styles for a more polished look.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Renamed' | translate }} <strong>{{ 'Billing' | translate }}</strong> to <strong>{{ 'Pricing' | translate }}</strong> {{ 'throughout the builder for clearer terminology.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'addons condition' | translate }}</strong> {{ 'display — addons now show correctly based on their configured conditions.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'Stock Manager' | translate }}</strong> {{ 'role issues — disabled unnecessary sections and improved variation product handling.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'notifications pagination' | translate }}</strong> {{ '— per-page count now works correctly in the notifications list.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          <span class="websitePadder">{{ 'Website' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'website categories' | translate }}</strong> {{ 'not saving when manually selected.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'header design' | translate }}</strong> {{ '— classic template items now align correctly in the center.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'order display limit' | translate }}</strong> {{ '— orders now load correctly without hitting an unintended cap.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'logo size' | translate }}</strong> {{ 'rendering in the app header.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'image and button links' | translate }}</strong> {{ '— tapping images and buttons now correctly navigates to their assigned links.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'incorrect stock handling' | translate }}</strong> {{ '— stock and price values are now validated and saved correctly as numbers, preventing corrupted inventory data.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed missing' | translate }} <strong>translations</strong> {{ 'across several builder sections.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'order subtotal' | translate }}</strong> {{ '— subtotal now calculates and displays correctly in order details.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'stock restoration on order cancellation' | translate }}</strong> {{ '— product stock is automatically restored when an order is cancelled.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'product filtering by category' | translate }}</strong> {{ '— products now filter correctly when a category is selected.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'missing data in single order' | translate }}</strong> {{ 'view — all order details now load correctly.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed' | translate }} <strong>{{ 'product limit' | translate }}</strong> {{ '— products can now be added correctly after reaching the previous cap.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 7.1' | translate }}</mat-card-title>
    <mat-card-subtitle>19-01-2026</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'UX / UI Updates' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Redesigned the' | translate }} <strong>{{ 'Orders' | translate }}</strong> {{ 'page for better clarity, improved filtering, and a smoother navigation experience.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Enhanced the' | translate }} <strong>{{ 'Categories' | translate }}</strong> {{ 'page layout to make category management faster and more intuitive.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Updated the' | translate }} <strong>{{ 'Users' | translate }}</strong> {{ 'page UI to improve readability and simplify user actions.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Refined the' | translate }} <strong>{{ 'Products' | translate }}</strong> {{ 'page design for clearer product information and easier management.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 7.0' | translate }}</mat-card-title>
    <mat-card-subtitle>01-01-2026</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'New Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Zoho integration' | translate }}</strong> {{ 'for syncing' | translate }} <strong>products</strong>, <strong>orders</strong>.
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Odoo integration' | translate }}</strong> {{ 'for syncing' | translate }} <strong>products</strong>, <strong>orders</strong>{{ ', and' | translate }} <strong>categories</strong>.
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added a new' | translate }} <strong>{{ 'Category Name Position' | translate }}</strong> {{ 'option in Categories styles.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          <span class="websitePadder">{{ 'Website' | translate }}</span>
          {{ 'Introduced the new' | translate }} <strong>{{ 'Website Builder' | translate }}</strong> {{ 'to create and manage websites from the dashboard.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'product visibility rules' | translate }}</strong> {{ 'to show products for specific' | translate }} <strong>customers</strong> and <strong>locations</strong>.
        </li>
      </ul>

      <h2>{{ 'Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Moved the' | translate }} <strong>{{ 'Views and Templates' | translate }}</strong> {{ 'tab from the side menu to the header to make navigation clearer and easier.' | translate }}
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added a' | translate }} <strong>{{ 'Smart Indexing' | translate }}</strong> {{ 'option for projects with large numbers of' | translate }} <strong>products</strong> and <strong>orders</strong> {{ 'to improve' | translate }} <strong>speed</strong> and <strong>stability</strong>.
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.26' | translate }}</mat-card-title>
    <mat-card-subtitle>27-11-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'New Features' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'Category Filter' | translate }}</strong> {{ 'inside the Products page to filter products by category.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Improved overall' | translate }} <strong>{{ 'data loading speed' | translate }}</strong> {{ 'when fetching products.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Enhanced' | translate }} <strong>{{ 'mobile design' | translate }}</strong> {{ 'for the Products page to improve usability on small screens.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.25' | translate }}</mat-card-title>
    <mat-card-subtitle>29-10-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'New Features' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added full' | translate }} <strong>{{ 'WordPress integration' | translate }}</strong> {{ 'including syncing of Products, Categories, and Orders.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added an option to' | translate }} <strong>{{ 'show variation image as the main product image' | translate }}</strong>.
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added a new' | translate }} <strong>{{ 'Unified Orders Page' | translate }}</strong> {{ 'combining orders from the App, Website, QR Menu, and POS System, with full source filtering.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Enhanced syncing stability for large WordPress stores.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Improved error handling during data fetch from WordPress.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed ID mismatch issues between WordPress products and Stacks products.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed duplicated category entries appearing during sync.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed a bug where' | translate }} <strong>{{ 'invalid variation values' | translate }}</strong> (deleted attribute options) were still saved; outdated values are now removed automatically.
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed a bug where' | translate }} <strong>{{ 'Guest Mode was always enabled' | translate }}</strong>.
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.20' | translate }}</mat-card-title>
    <mat-card-subtitle>03-09-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'New Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added' | translate }} <strong>{{ 'points discount' | translate }}</strong> {{ 'support in Builder and on the single-order page.' | translate }}
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Enabled' | translate }} <strong>{{ 'product description translation' | translate }}</strong>.
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added currency:' | translate }} <strong>Tunisian Dinar (TND)</strong>.
        </li>
      </ul>

      <h2>{{ 'Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Improved overall' | translate }} <strong>translations</strong> {{ 'quality.' | translate }}
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Exports now include a new column:' | translate }} <code>productformat</code>.
        </li>
      </ul>

      <h2>{{ 'Bug Fixes' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Product' | translate }} <strong>import</strong> {{ 'now defaults items to' | translate }} <strong>physical</strong> (no longer digital by default).
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed product import: when' | translate }} <em>{{ 'Skip images' | translate }}</em> {{ 'is selected, existing images are preserved and no empty images are added.' | translate }}
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed a bug where' | translate }} <strong>{{ 'Guest Mode was always enabled' | translate }}</strong> {{ 'even when turned off.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.19' | translate }}</mat-card-title>
    <mat-card-subtitle>11-08-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'New Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Integrated Meta Pixel tracking for improved analytics' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Support for' | translate }} <strong>{{ 'PDF in Products' | translate }}</strong>{{ ': Users can now view attached PDF files directly in the product details.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Enabled email notifications for new orders' | translate }}
        </li>
      </ul>

      <h2>{{ 'Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Adjusted design for better appearance on iOS devices' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Enhanced product and order management tools' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Improved product import process to prevent duplicate products' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Categories now accept normal strings instead of only numeric values' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed occasional glitches when selecting the translate option' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.18' | translate }}</mat-card-title>
    <mat-card-subtitle>6-07-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Adjust Medium Button size' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Removed decimal values and improved points & rewards design' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added new feature: earn points by inviting others via referral' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Unified coupon and points discounts into total price calculation' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Prevented redeemed points from reducing shipping cost' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Displayed coupon and points savings in red with negative values' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Improved redemption message handling and validation logic' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.17' | translate }}</mat-card-title>
    <mat-card-subtitle>25-06-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added support for Meta Pixel tracking to enable conversion analytics and remarketing.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.16' | translate }}</mat-card-title>
    <mat-card-subtitle>19-06-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed issue where the importer was importing products as variables instead of simple products' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed long category names breaking the layout style' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Adjusted layout styling in the order summary screen' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed category paginator not updating properly on page change' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed shipping paginator issue with displaying correct entries' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.15' | translate }}</mat-card-title>
    <mat-card-subtitle>15-06-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added support for importing' | translate }} <strong>{{ 'digital products' | translate }}</strong>.
        </li>
      </ul>

      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Areas is now fully translatable' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Address form now supports building name and number' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed issue where the size chart was not appearing' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed issue where related products in the product details page were not scrollable' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.14' | translate }}</mat-card-title>
    <mat-card-subtitle>03-06-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Support for' | translate }} <strong>{{ 'Digital Products' | translate }}</strong>{{ ': Users can now purchase and receive digital items such as tickets and codes directly in the app.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Integrated' | translate }} <strong>{{ 'Google Maps' | translate }}</strong> {{ 'in address selection: Users can pin their location, and store admins can manage locations more accurately.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added option to enable the' | translate }} <strong>{{ 'default back button' | translate }}</strong> {{ 'in the header for improved navigation.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added support for' | translate }} <strong>Kuwaiti Dinar (KWD)</strong> {{ 'as a store currency.' | translate }}
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed an issue where changes in' | translate }} <strong>{{ 'E-commerce Settings' | translate }}</strong> {{ 'were not being saved properly.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Profile page is now fully translatable, supporting all available app languages.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed an issue where' | translate }} <strong>{{ 'category images' | translate }}</strong> appeared stretched; images now maintain proper aspect ratio.
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Fixed an issue where the' | translate }} <strong>{{ 'header was missing' | translate }}</strong> {{ 'on the My Account page.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.11' | translate }}</mat-card-title>
    <mat-card-subtitle>15-04-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Hide Product option, now supports automatically hiding products that are out of stock.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Payments Gateways page, manage all payment gateways from a single place.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Order details now display the coupon code used by the customer, along with the shipping cost.' | translate }}
        </li>

        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Address picker powered by Google Maps, customers can pin their location directly on the map.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Redesigned image section in Product Details for a cleaner layout and easier media management.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Performance optimisations: faster load times and smoother handling of large product catalogues.' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Fixed an issue where users logging in from iOS devices were not listed on the Users page.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.10' | translate }}</mat-card-title>
    <mat-card-subtitle>15-03-2025</mat-card-subtitle>

    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Hide Product option, lets you hide any product' | translate }}
        </li>

        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Payments Gateways page, manage all payment gateways from a single place.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Performance optimisations: faster load times and smoother handling of large product catalogs.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.9' | translate }}</mat-card-title>
    <mat-card-subtitle>1-3-2025</mat-card-subtitle>
    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Order tracking in app' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Missing sort and filter options' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Push Notification Event Based' | translate }}
        </li>
        <li>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'User role to view orders, another one to manage products and orders' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Added more text translations.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'translate Adress pages' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.8' | translate }}</mat-card-title>
    <mat-card-subtitle>19-2-2025</mat-card-subtitle>
    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added support for multiple addresses.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Implemented estimated delivery time feature.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added search page.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Integrated related products in builder and product pages.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added option to hide product names.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added option to change the back button to a menu button.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Added size chart in product details.' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Adjusted image dimensions on the Single Product Page to match the required portrait size' | translate }}
        </li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          {{ 'Implemented wishlist.' | translate }}
        </li>
      </ul>

      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Adjusted the design of the order page.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Added more text translations.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Fixed issue where the auto-translate button didn\'t work when no countries were set in shipping.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Added support for translating numbers to Arabic.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Displayed the Product SKU on a single product page.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Translated the Contact Us page.' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.7' | translate }}</mat-card-title>
    <mat-card-subtitle>1-2-2025</mat-card-subtitle>
    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span>
          {{ 'Upgraded points and rewards system to support multiple points and rewards.' | translate }}
        </li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.6' | translate }}</mat-card-title>
    <mat-card-subtitle>20-1-2025</mat-card-subtitle>
    <mat-card-content>
      <h2>{{ 'Bug Fixes & Improvements' | translate }}</h2>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Changed project password requirements to include only lowercase letters and numbers.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Adjusted design for toasters displaying new orders.' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.5' | translate }}</mat-card-title>
    <mat-card-subtitle>8-1-2025</mat-card-subtitle>
    <mat-card-content>
      <h2>{{ 'Features' | translate }}</h2>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Redesigned the first screen of the sample app.' | translate }}</li>
        <li>
          <span class="greenPadder">{{ 'App' | translate }}</span>
          <span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Added translations for countries and cities.' | translate }}
        </li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Enabled search for products or categories in different languages.' | translate }}</li>
      </ul>
      <h2>{{ 'Bug Fixes' | translate }}</h2>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Removed posts from the search page.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Improved the design of the search page.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Translated product variations.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Adjusted RTL styling in product details.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Updated push notification styles.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Displayed user nicknames.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Corrected various typos.' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title>{{ 'Version 6.4' | translate }}</mat-card-title>
    <mat-card-subtitle>1-1-2025</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Firebase Analytics' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Min & max sale and regular displayed prices issue' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Adjust the search page to be as the others, in terms of structure and design' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Login & signup pages style' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Resolve Errors from Translating into Multiple Languages' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 6.3' | translate }}</mat-card-title>
    <mat-card-subtitle>24-12-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Choose specific page to redirect the user to after signing up' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Searching input bug' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Sticky header style' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Translate footer text' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Latest orders categorized on top' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 6.21' | translate }}</mat-card-title>
    <mat-card-subtitle>12-12-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Updated Preview: Added QR code to download sample apps.' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Adjusted fonts for Points & Rewards.' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 6.2' | translate }}</mat-card-title>
    <mat-card-subtitle>26-11-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> <span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Human Readable Order Id' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Footer in my orders page' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'The header and footer on the About page are fixed' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 6.11' | translate }}</mat-card-title>
    <mat-card-subtitle>26-11-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Change project samples' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Resolved an issue on the cart page where no message was displayed when the cart was empty. Added a placeholder message: "Your cart is empty."' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Mobile number is now optional for returning customers starting from their second order, enhancing the checkout experience.' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Resolved an issue where category names were not translating correctly on the single page' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 6.1' | translate }}</mat-card-title>
    <mat-card-subtitle>21-11-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Auth0 login system' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'New order notification' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Cart page back button bug' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 6' | translate }}</mat-card-title>
    <mat-card-subtitle>27-9-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Points and rewards system' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Coupon management system' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Mobile number is not required after the second order' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.7' | translate }}</mat-card-title>
    <mat-card-subtitle>15-7-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Multilingual' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Add delete order and go to the home button in the order summary' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fixing style conflict' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Submit order design system' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.4' | translate }}</mat-card-title>
    <mat-card-subtitle>10-2-2024</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Add multi-country selection' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Update swiper' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Add the country option on checkout pages' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Fix FooterActive Error' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.2' | translate }}</mat-card-title>
    <mat-card-subtitle>28-05-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Builder version history' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Checkout fields are editable from the builder' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix saving errors' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.1.1' | translate }}</mat-card-title>
    <mat-card-subtitle>18-05-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Allow unlimited blocks to be added in any view' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Allow Posts Block in custom views' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix Arabic Variations in Variable Products retrieval' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.1' | translate }}</mat-card-title>
    <mat-card-subtitle>10-05-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Allow users to signup, login and checkout with their phone number instead of email' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'possibility to choose between required phone or email on signup' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Loyalty Points and Rewards feature integration, integration with plugin WooCommerce Points and Rewards' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.7' | translate }}</mat-card-title>
    <mat-card-subtitle>28-04-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li><span class="darkBluePadder">{{ 'Plugin' | translate }}</span> {{ 'Intro Screen for the plugin with important action buttons to the builder' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.6' | translate }}</mat-card-title>
    <mat-card-subtitle>20-04-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Fix Product selection in image and button' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix Disable Guest Login' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Make postalcode, lastname in checkout page not required fields' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.5' | translate }}</mat-card-title>
    <mat-card-subtitle>12-04-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Posts Block with Categories Selection' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Select posts in Image and Buttons Blocks' | translate }}</li>
        <li><span class="bluePadder">{{ 'Builder' | translate }}</span> {{ 'Global Header and Footer rendering with their icons' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.4' | translate }}</mat-card-title>
    <mat-card-subtitle>05-04-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Remove Addons dependency on single view' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.3' | translate }}</mat-card-title>
    <mat-card-subtitle>09-03-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Delete Order and Delete Coupon and Delete Cart item' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Categories linked from Button, Image and Footer' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.2' | translate }}</mat-card-title>
    <mat-card-subtitle>02-03-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix posts limit' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0.1' | translate }}</mat-card-title>
    <mat-card-subtitle>02-27-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix Categories Rendering' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix Posts Rendering' | translate }}</li>
        <li><span class="greenPadder">{{ 'App' | translate }}</span> {{ 'Fix Products Rendering' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 5.0' | translate }}</mat-card-title>
    <mat-card-subtitle>01-02-2023</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li>{{ 'Rest of Views are Editable' | translate }}</li>
        <li>{{ 'Possibility to add, edit or delete custom view' | translate }}</li>
        <li>{{ 'Link from any view to another' | translate }}</li>
        <li>{{ 'Add Global Header' | translate }}</li>
        <li>{{ 'Add Header per view' | translate }}</li>
        <li>{{ 'Possibility to disable Header on specific views' | translate }}</li>
        <li>{{ 'Add Global Footer' | translate }}</li>
        <li>{{ 'Add Footer per view' | translate }}</li>
        <li>{{ 'Possibility to disable Footer on specific views' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.8.3' | translate }}</mat-card-title>
    <mat-card-subtitle>20-12-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Feature' | translate }}</p>
      <ul>
        <li>{{ 'Handle multiple projects connected to the same site' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.8.2' | translate }}</mat-card-title>
    <mat-card-subtitle>27-11-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Fix rendering membership courses with categories selected' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.8' | translate }}</mat-card-title>
    <mat-card-subtitle>23-11-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Integrate with Paid Memberships Pro plugin to render courses and lessons' | translate }}</li>
        <li>{{ 'Full Flow for the application for the memberships' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.7.3' | translate }}</mat-card-title>
    <mat-card-subtitle>18-10-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Fix Products Block Rendering' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.7.2' | translate }}</mat-card-title>
    <mat-card-subtitle>04-10-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Change servers infrastructure' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.7.1' | translate }}</mat-card-title>
    <mat-card-subtitle>09-08-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Fix Mobile Checkout' | translate }}</li>
        <li>{{ 'Fix Switching between views conflict in data' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.7' | translate }}</mat-card-title>
    <mat-card-subtitle>01-08-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Redesign the Application to be trendy' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Fix Youtube Fullscreen view' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.9' | translate }}</mat-card-title>
    <mat-card-subtitle>08-06-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Post Block Renders Custom Post Types' | translate }}</li>
        <li>{{ 'Footer Menu Items Renders Custom Post Types' | translate }}</li>
        <li>{{ 'Native Checkout along with webview checkout' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Load more in products block' | translate }}</li>
        <li>{{ 'Fix Youtube Flicker Effect' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.8' | translate }}</mat-card-title>
    <mat-card-subtitle>25-05-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Stacks Translation: Multilingual Support with Polylang integration and Hayyan for WooCommerce, Added default arabic translation' | translate }}</li>
        <li>{{ 'Stacks Plugin code restructured and cleanedup' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.7' | translate }}</mat-card-title>
    <mat-card-subtitle>16-05-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Stacks Analytics: Viewing Mobile Visits Statistics and Mobile App Orders' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.6' | translate }}</mat-card-title>
    <mat-card-subtitle>10-05-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Integration with Google Admob Banner Ads for Android and IOS' | translate }}</li>
        <li>{{ 'Fading animation on application opening' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Time needed to correctly load header and footer is fixed' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.5' | translate }}</mat-card-title>
    <mat-card-subtitle>13-04-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Youtube Video updated to work with normal url, just paste your url and we will convert it for you' | translate }}</li>
        <li>{{ 'Each Trial will work with an independent site to prevent conflicts in the data' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.4' | translate }}</mat-card-title>
    <mat-card-subtitle>28-03-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'New Builder Design that fits better with most of the screen sizes' | translate }}</li>
        <li>{{ 'Cleanup all icons' | translate }}</li>
        <li>{{ 'Remove update buttons from incorrect places' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.3' | translate }}</mat-card-title>
    <mat-card-subtitle>17-03-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Header icons can be enabled or disabled' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Header Shadow appears in expanded search and non expanded' | translate }}</li>
        <li>{{ 'Products Block : Select Products by Category retrieves correct products now "Plugin Version 4.5.7"' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.2' | translate }}</mat-card-title>
    <mat-card-subtitle>28-02-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Handle no image in categories block case' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Fixed External URL in Footer' | translate }}</li>
        <li>{{ 'Render Categories from all languages' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6.1' | translate }}</mat-card-title>
    <mat-card-subtitle>21-02-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Mobile Application Redesigned' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Mobile Application Fonts Adjusted' | translate }}</li>
        <li>{{ 'Mobile Application Margins Fixed' | translate }}</li>
        <li>{{ 'Mobile Application Products and Categories Blocks images Fixed' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.6' | translate }}</mat-card-title>
    <mat-card-subtitle>27-01-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Menu in the Footer' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Show error messages in details that happens while building the app' | translate }}</li>
        <li>{{ 'Disable Guest User Feature Fixed' | translate }}</li>
        <li>{{ 'Fix Push Notifications Users Listing' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.5.1' | translate }}</mat-card-title>
    <mat-card-subtitle>16-01-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Preview Real app in the builder' | translate }}</li>
        <li>{{ 'Added How it works to all pages' | translate }}</li>
      </ul>
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>[Mobile App] Fix Back Button Color to match the header icon colors</li>
        <li>[Mobile App] Trim all the shortcodes from the product description page</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.5' | translate }}</mat-card-title>
    <mat-card-subtitle>06-01-2022</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Add Possibility to Edit The design of Pages other than Home' | translate }}</li>
        <li>{{ 'Edit the Design of the Categories Page through Stacks Builder' | translate }}</li>
        <li>{{ 'Edit the Design of the Single Products Page through Stacks Builder' | translate }}</li>
        <li>{{ 'Modify the Projects Design' | translate }}</li>
        <li>{{ 'Add capability to deactivate or activate a project' | translate }}</li>
      </ul>
      <br />
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Fix Video rendering in the application' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-title>{{ 'Version 4.4.1' | translate }}</mat-card-title>
    <mat-card-subtitle>18-11-2021</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Add Global Font Families and Font Sizes that reflects in the whole app' | translate }}</li>
        <li>{{ 'Add 1000+ Google Font to the Application' | translate }}</li>
        <li>{{ 'New Layout for Products 3 Columns Grid' | translate }}</li>
        <li>{{ 'Add to cart button for Products in Single Category Page' | translate }}</li>
        <li>{{ 'Redesign Single Category with subcategories page' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <br />
  <mat-card>
    <mat-card-title>{{ 'Version 4.4' | translate }}</mat-card-title>
    <mat-card-subtitle>31-10-2021</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ '1 Click Apple Build Process with automatic uploader to itunes' | translate }}</li>
        <li>{{ 'HTML in Block, Add Fonts, Horizontal Lines etc ...' | translate }}</li>
      </ul>
      <br />
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Checkout Editor for WooCommerce Plugin conflict fix' | translate }}</li>
        <li>{{ 'Empty Page after Update' | translate }}</li>
        <li>{{ 'Content Settings wasn\'t rendering data correctly in mobile app' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <br />
  <mat-card>
    <mat-card-title>{{ 'Version 4.3' | translate }}</mat-card-title>
    <mat-card-subtitle>21-10-2021</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Introducing Button Block, Now you can add a button that redirects to your single post, product, category or an external webview' | translate }}</li>
        <li>{{ 'Images are now linked and can redirect to your single post, product, category or an external webview' | translate }}</li>
        <li>{{ 'An option to make Search expanded by default' | translate }}</li>
        <li>{{ 'AAB Files for Google Play, this is the extension required to be uploaded to google play instead of APK Files' | translate }}</li>
        <li>{{ 'Text Block, now you can colorize each part of the Text independently' | translate }}</li>
        <li>{{ 'You can now view Blog posts with specific categories' | translate }}</li>
      </ul>
      <br />
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Issue with Free Trial fixed, now if the free trial ends then you can create a new trial from within the builder' | translate }}</li>
        <li>{{ 'Building Issue stucks at 66% fixed' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <br />
  <mat-card>
    <mat-card-title>{{ 'Version 4.2' | translate }}</mat-card-title>
    <mat-card-subtitle>1-10-2021</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Introducing Posts Block, Now you can integrate with your Magazine or News' | translate }}</li>
      </ul>
      <br />
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'Add Dimension requirements over icons and splash screens' | translate }}</li>
        <li>{{ 'Video Block Blinking Issue Fixed' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <br />
  <mat-card>
    <mat-card-title>{{ 'Version 4.1' | translate }}</mat-card-title>
    <mat-card-subtitle>1-9-2021</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Send unlimited Push Notifications to your customers with offers or new products' | translate }}</li>
        <li>{{ 'Allow your customers to login with Facebook Login' | translate }}</li>
      </ul>
      <br />
      <p>{{ 'Bug Fixes' | translate }}</p>
      <ul>
        <li>{{ 'blocks negative margins is introduced to decrease the margin of the elements' | translate }}</li>
        <li>{{ 'login issues between stacks and builder' | translate }}</li>
        <li>{{ 'Products and Categories wasn\'t working on some Websites, now it is fixed' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
  <br />
  <mat-card>
    <mat-card-title>{{ 'Version 4' | translate }}</mat-card-title>
    <mat-card-subtitle>1-8-2021</mat-card-subtitle>
    <mat-card-content>
      <p>{{ 'Features' | translate }}</p>
      <ul>
        <li>{{ 'Launch of Stacks Drag and Drop builder' | translate }}</li>
        <li>{{ 'Total Revamp of the User Experience' | translate }}</li>
        <li>{{ '10X Faster and More reliable experience' | translate }}</li>
        <li>{{ 'Develop the builder to be single page application' | translate }}</li>
      </ul>
    </mat-card-content>
  </mat-card>
</div>
